import { render, staticRenderFns } from "./participants.vue?vue&type=template&id=2137254d&scoped=true&"
import script from "./participants.vue?vue&type=script&lang=js&"
export * from "./participants.vue?vue&type=script&lang=js&"
import style0 from "./participants.vue?vue&type=style&index=0&id=2137254d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137254d",
  null
  
)

export default component.exports